import { Injectable } from '@angular/core';
import {
  BehaviorSubject,
  catchError,
  map,
  Observable,
  of,
  switchMap,
} from 'rxjs';
import { Router } from '@angular/router';
import { CalAngularService } from '@cvx/cal-angular';
import { SessionStorageService } from '../core/services/session-storage';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CalService {
  private readonly cal: CalAngularService;
  public readonly isLoggedInSubject: BehaviorSubject<boolean> =
    new BehaviorSubject(false);
  currentUser: any[] = [];

  constructor(
    authService: CalAngularService,
    private readonly router: Router,
    private readonly session: SessionStorageService
  ) {
    this.cal = authService;
  }

  isUserLoggedIn(): Observable<boolean> {
    return this.isLoggedInSubject.asObservable();
  }

  signIn(): Observable<boolean> {
    return this.cal.userInitiatedSignIn().pipe(
      switchMap(() => {
        if (this.cal.isUserSignedIn()) {
          return this.currentUserDetails();
        } else {
          return of(false);
        }
      })
    );
  }

  currentUserDetails(): Observable<boolean> {
    return this.cal
      .getUserPropertiesFromMsGraph([
        'givenName',
        'cai',
        'jobTitle',
        'surname',
        'mail',
        'Id',
      ])
      .pipe(
        map((graphProp) => {
          if (graphProp) {
            this.session.setItem(
              'UserName',
              `${graphProp['givenName']} ${graphProp['surname']}`
            );
            this.session.setItem('UserEmail', graphProp['mail']);
            this.isLoggedInSubject.next(true);
            return true;
          } else {
            return false;
          }
        })
      );
  }

  getUserImpersonationToken(): Observable<boolean> {
    const envUrl = environment.production
      ? 'https://pna-prod.azure.chevron.com'
      : 'https://pna-test.azure.chevron.com';

    const scope = [`${envUrl}/user_impersonation`];

    return this.cal.getAADToken(scope).pipe(
      map((token: any) => {
        if (token) {
          this.session.setItem(
            'accessToken',
            JSON.parse(JSON.stringify(token))
          );
          return true;
        }
        return false;
      }),
      catchError((error) => {
        console.error('Error while fetching user_impersonation data:', error);
        return of(false);
      })
    );
  }

  getToken(): Observable<boolean> {
    return this.cal.getAADToken().pipe(
      map((token: any) => {
        if (token) {
          this.session.setItem('token', JSON.parse(JSON.stringify(token)));
          return true;
        }
        return false;
      }),
      catchError((error) => {
        console.error('Error Fetching data:', error);
        return of(false);
      })
    );
  }

  public logout() {
    this.cal.userInitiatedSignOut();
    this.router.navigate(['']);
  }
}
